import { getStore } from "store";
import me from "models/me";
import { toggleWorkingOrderLoadingDialog } from "actions/app";
import isEqual from "lodash/isEqual";
import cookie from "react-cookie";

export default function (nextState, replace) {
    const { location } = nextState;
    const { accesstoken, wo, campaignId } = location.query;
    const { brand = "" } = nextState.params;
    const sanitizedQuery = Object.assign({}, location.query);

    if (accesstoken) {
        delete sanitizedQuery.accesstoken;
    }

    // further url processing is performed is user is not redirected to profile page
    // to change his temporary password
    if (!me.using_temp_password) {
        const store = getStore();
        if (wo) {
            delete sanitizedQuery.wo;
            if (store && wo === "true") {
                store.dispatch(toggleWorkingOrderLoadingDialog(true));
            }
        }

        if (campaignId && me._id && brand && me.account_type === "buyer") {
            cookie.save(`user_${me._id}_campaign_for_${brand}`, campaignId, {
                path: "/",
                domain: window.location.host.replace(/^app/, ""),
            });

            delete sanitizedQuery.campaignId;
        }
    }

    if (!isEqual(location.query, sanitizedQuery)) {
        replace({
            pathname: location.pathname,
            query: sanitizedQuery,
        });
    }
}
